import "./AppVersions.scss";
import useAppVersions from "./useAppVersions";
import AppVersionsHeader from "./AppVersionsHeader";
import AppVersionsSummary from "./AppVersionsSummary";
import AppVersionsTable from "./AppVersionsTable";
import AppVersionFormModal from "./AppVersionFormModal";

export default function AppVersions() {
  const {
    rows,
    page,
    rowsPerPage,
    totalRows,
    isLoading,
    fetchError,
    searchQuery,
    platformFilter,
    latestVersions,
    addModalOpen,
    isSubmitting,
    addForm,
    errors,
    retryFetchVersions,
    handleSearchChange,
    handlePlatformFilterChange,
    handleChangePage,
    handleChangeRowsPerPage,
    openAddModal,
    closeAddModal,
    handleChange,
    handleSubmit,
  } = useAppVersions();

  return (
    <div className="mainadd">
      <AppVersionsSummary latestVersions={latestVersions} />

      <AppVersionsHeader
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        platformFilter={platformFilter}
        onPlatformFilterChange={handlePlatformFilterChange}
        onAddVersion={openAddModal}
      />

      <AppVersionsTable
        rows={rows}
        isLoading={isLoading}
        fetchError={fetchError}
        onRetry={retryFetchVersions}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <AppVersionFormModal
        open={addModalOpen}
        onClose={closeAddModal}
        addForm={addForm}
        errors={errors}
        onChange={handleChange}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
    </div>
  );
}
